import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc, doc, updateDoc, getDoc } from 'firebase/firestore';

const VehicleForm = ({ itemData, onClose }) => {
    const [nazevVozidla, setNazevVozidla] = useState(itemData ? itemData.name : '');
    const [popis, setPopis] = useState(itemData ? itemData.description : '');
    const [fotka, setFotka] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cloudinaryConfig, setCloudinaryConfig] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCloudinaryConfig = async () => {
            try {
                const configRef = doc(db, 'config', 'cloudinary');
                const configSnap = await getDoc(configRef);
                if (configSnap.exists() && configSnap.data().cloud_name && configSnap.data().upload_preset) {
                    setCloudinaryConfig(configSnap.data());
                } else {
                    setError('Cloudinary konfigurácia nebola nájdená alebo je nekompletná. Prosím, nastavte ju v sekcii Konfigurace.');
                }
            } catch (err) {
                console.error("Error fetching Cloudinary config:", err);
                setError('Nepodarilo sa načítať Cloudinary konfiguráciu.');
            }
        };

        fetchCloudinaryConfig();
    }, []);

    const handleNazevVozidlaChange = (e) => {
        setNazevVozidla(e.target.value);
    };

    const handlePopisChange = (e) => {
        setPopis(e.target.value);
    };

    const handleFotkaChange = (e) => {
        if (e.target.files[0]) {
            setFotka(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!cloudinaryConfig) {
            setError("Cloudinary konfigurácia sa nenačítala. Nahrávanie súboru nie je možné.");
            setLoading(false);
            return;
        }

        let photoURL = itemData?.photoURL || null;
        const uploadPreset = cloudinaryConfig.upload_preset;

        try {
            if (fotka) {
                // Upload new photo to Cloudinary
                const formData = new FormData();
                formData.append('file', fotka);
                formData.append('upload_preset', uploadPreset);
                formData.append('quality', 'auto:best'); // Automatically adjust quality
                formData.append('max_bytes', 10485760); // Set max file size to 10MB

                const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error.message || 'Cloudinary upload failed');
                }

                const data = await response.json();
                photoURL = data.secure_url;
            } else if (!itemData) {

                if (!itemData?.photoURL) {
                    throw new Error('Prosím, nahrajte fotku vozidla.');
                }
            }

            const vehicleData = {
                name: nazevVozidla,
                description: popis,
                photoURL: photoURL,
            };

            if (itemData) {

                const vehicleDocRef = doc(db, 'vehicles', itemData.id);
                await updateDoc(vehicleDocRef, vehicleData);

            } else {

                await addDoc(collection(db, 'vehicles'), {
                    ...vehicleData,
                    createdAt: new Date()
                });

                alert('Vozidlo úspěšně přidáno!');
                setNazevVozidla('');
                setPopis('');
                setFotka(null);
            }

            onClose();
        } catch (error) {
            console.error('Chyba při ukládání vozidla:', error);
            setError(`Nastala chyba při ukládání vozidla: ${error.message || error}. Zkuste to prosím znovu.`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-4 text-gray-800">
            <h2 className="text-2xl font-bold mb-4">{itemData ? 'Upravit Vozidlo' : 'Přidat Vozidlo'}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="nazevVozidla" className="block text-sm font-medium mb-1">
                        Název vozidla
                    </label>
                    <input
                        type="text"
                        id="nazevVozidla"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={nazevVozidla}
                        onChange={handleNazevVozidlaChange}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="popis" className="block text-sm font-medium mb-1">
                        Popis
                    </label>
                    <textarea
                        id="popis"
                        rows="3"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={popis}
                        onChange={handlePopisChange}
                        required
                    ></textarea>
                </div>
                <div>
                    <label htmlFor="fotka" className="block text-sm font-medium mb-1">
                        Fotka
                    </label>
                    {itemData && itemData.photoURL && (
                        <p className="text-sm text-gray-600 mb-2">Současná fotka: <a href={itemData.photoURL} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Zobrazit</a></p>
                    )}
                    <input
                        type="file"
                        id="fotka"
                        accept="image/*"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline
             file:mr-4 file:py-2 file:px-4
             file:rounded-md file:border-0
             file:mr-4 file:py-2 file:px-4
             file:text-sm file:font-semibold
             file:bg-blue-500 file:text-white
             hover:file:bg-blue-700"
                        onChange={handleFotkaChange}
                        {...(!itemData && { required: true })}
                    />
                </div>
                {error && (
                    <p className="text-red-500 text-sm italic my-4 p-3 bg-red-100 rounded">{error}</p>
                )}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50 transition duration-300"
                        disabled={loading}
                    >
                        {loading ? 'Ukládám...' : (itemData ? 'Upravit Vozidlo' : 'Přidat Vozidlo')}
                    </button>
                    {onClose && (
                        <button type="button" onClick={onClose} className="ml-4 text-gray-600 hover:text-gray-800">Zrušit</button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default VehicleForm;